/* eslint-disable react/prop-types */
import React, { useState } from "react"; // React Stuff
import axios from "axios";
import { Col, Row, Form, Button } from "react-bootstrap";

const SetTutor = (props) => {
  const [selectedTutorID, setSelectedTutorID] = useState("");
  const Type = props.BookingType;
  // handle tutor change
  const handleTutorSubmit = async (e) => {
    e.preventDefault();
    const tutorSetRequest = await axios.post(
      `/api/admin/manage/tutor/${props.data._id}/${selectedTutorID}/${Type}`,
      {
        withCredentials: true,
      }
    );
    if (tutorSetRequest.status === 200) {
      props.setSubmitClicked(false);
      props.fetchNewData();
      return props.setSuccessMessage("Tutor successfully changed.");
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };
  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3' sm='12'>
        {props.tutors.length > 0 ? (
          <div className='p-2 mx-auto'>
            <h3>Set Tutor</h3>
            <span>
              Tutor Set:
              {props.data.Tutor === undefined ? (
                <>{" None"}</>
              ) : (
                <>{" " + props.data.Tutor.First_Name + " " + props.data.Tutor.Last_Name}</>
              )}
            </span>
            <Form className='post' onSubmit={handleTutorSubmit}>
              <Form.Control
                as='select'
                value={selectedTutorID}
                onChange={(e) => setSelectedTutorID(e.target.value)}
                required
                custom
              >
                {" "}
                <option value='' disabled defaultValue>
                  Select your option
                </option>
                {props.tutors.map((Tutors) => (
                  <option key={Tutors._id} value={Tutors._id}>
                    {Tutors.First_Name + " " + Tutors.Last_Name}
                  </option>
                ))}
              </Form.Control>
              <Button
                variant='primary'
                className='w-100 mt-3 mb-3'
                type='submit'
                disabled={props.submitClicked}
              >
                Assign Tutor
              </Button>
            </Form>
          </div>
        ) : (
          <p className='mt-4'>You need to set up tutors.</p>
        )}
      </Col>
    </Row>
  );
};

export default SetTutor;
